import { OTPConfig } from '../../shares/model/config';

abstract class OTPProvider {
  protected otpConfig: OTPConfig; //Record<string, any>;

  constructor(otpConfig: OTPConfig) {
    if (new.target === OTPProvider) {
      throw new Error(
        'Cannot instantiate abstract class OTPProvider directly.',
      );
    }
    this.otpConfig = otpConfig;
  }

  abstract getOTP(gameId?: string): Promise<string | void>;
}

export default OTPProvider;
